import React from 'react';
import { Container, Section } from '../components/ui/Section';
import { PageHeader } from '../components/ui/PageHeader';
import { ChurchDirectory } from '../components/churches/ChurchDirectory';
import { ButtonExternal, ButtonLink } from '../components/ui/Button';
import { localChurches } from '../data/churches';
import { externalLinks } from '../data/site';
const helps = [{
  title: 'Ask a BCM student or leader',
  copy: 'Students at BCM attend churches all over the area. Asking someone on a Thursday night is the easiest way to find a ride and sit with people you already know.'
}, {
  title: 'Tell us what you’re looking for',
  copy: 'Share what kind of church community you are hoping to find and a BCM leader can help you think it through.'
}, {
  title: 'Visit with a friend first',
  copy: 'You never have to walk into a new church alone. Ask someone from BCM to go with you the first time.'
}];
export function LocalChurches() {
  return <>
      <PageHeader eyebrow="Resources" title="Looking for a local church?" intro="UCF BCM students attend churches throughout the Central Florida area. This page will help students explore churches that members of the BCM community currently attend." data-id="element-540" data-mp="ar1yhto2yiyp" />

      <Section className="bg-[#fffdf6] py-14 sm:py-18" labelledBy="church-directory-heading" data-id="element-541" data-mp="oqjogcd4429n">
        <Container data-id="element-542" data-mp="oo70nikoaxoo">
          <h2 id="church-directory-heading" className="sr-only" data-id="element-543" data-mp="tq62go0rlmji">
            Local church directory
          </h2>
          <ChurchDirectory churches={localChurches} data-id="element-544" data-mp="xqg6hv4zy2vq" />
        </Container>
      </Section>

      <Section className="bcm-paper py-14 sm:py-18" labelledBy="church-help-heading" data-id="element-545" data-mp="12hg5r71l8x1e">
        <Container data-id="element-546" data-mp="17grm4ey1m0ig">
          <h2 id="church-help-heading" className="font-serif text-3xl font-semibold leading-tight text-brand-navy sm:text-4xl" data-id="element-547" data-mp="17hav365ptekc">
            How to find a church in the meantime
          </h2>
          <ul className="mt-8 grid gap-5 sm:grid-cols-3" data-id="element-548" data-mp="1hfql15t0ahs9">
            {helps.map(help => <li key={help.title} className="rounded-[22px] border-2 border-brand-navy bg-white p-6" data-id="element-549" data-mp="rrl6obmlt7g2">
                <h3 className="font-display text-xl font-bold leading-snug text-brand-navy" data-id="element-550" data-mp="mtjpjw8qni78">
                  {help.title}
                </h3>
                <p className="mt-2 font-sans text-[15px] leading-relaxed text-ink" data-id="element-551" data-mp="wqg0s9q0uifh">{help.copy}</p>
              </li>)}
          </ul>

          <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:flex-wrap" data-id="element-552" data-mp="1ag9rkxl37cru">
            <ButtonExternal href={externalLinks.getConnectedForm} data-id="element-553" data-mp="15j9kqkgey5zo">Ask a BCM Leader</ButtonExternal>
            <ButtonExternal href={externalLinks.email} variant="secondary" data-id="element-554" data-mp="1kg0helypd3ll">
              Email UCF BCM
            </ButtonExternal>
            <ButtonLink to="/connect" variant="secondary" data-id="element-555" data-mp="1fhfhknnd4lxo">
              More ways to connect
            </ButtonLink>
          </div>
        </Container>
      </Section>
    </>;
}